import {
  FETCH_INFO_INTERVENTO,
  FETCH_INFO_INTERVENTO_SUCCESS,
  RESET_INFO_INTERVENTO,
  START_POLLING,
  STOP_POLLING,
  UPDATE_TIME_INFO,
  INCREMENT_CALL_NUMBER,
  RESET_FETCH_INFO_INTERVENTO_ENDED,
  SALVA_INFO_STRUTTURA,
  SET_RICERCA_EFFETTUATA,
} from "./index";

export const fetchInfoIntervento = (idStruttura, idPaziente) => ({
  type: FETCH_INFO_INTERVENTO,
  idStruttura,
  idPaziente,
});

export const fetchInfoInterventoSuccess = (infoIntervento) => ({
  type: FETCH_INFO_INTERVENTO_SUCCESS,
  infoIntervento,
});

export const resetInfoIntervento = () => ({
  type: RESET_INFO_INTERVENTO,
});

export const startPolling = (idStruttura, idPaziente) => ({
  type: START_POLLING,
  idStruttura,
  idPaziente,
});

export const stopPolling = () => ({
  type: STOP_POLLING,
});

export const updateTimeInfo = () => ({
  type: UPDATE_TIME_INFO,
});

export const incrementCallNumber = () => ({
  type: INCREMENT_CALL_NUMBER,
});

export const resetFetchInfoInterventoEnded = () => ({
  type: RESET_FETCH_INFO_INTERVENTO_ENDED,
});

export const salvaInfoStruttura = (idEnte, idStruttura) => ({
  type: SALVA_INFO_STRUTTURA,
  idEnte,
  idStruttura,
});

export const setRicercaEffettuata = (value) => ({
  type: SET_RICERCA_EFFETTUATA,
  value,
});
